// Modul zur Erfassung eines Durchführungszeitraums
"use strict";

import module from "./module.js";

export default module;
